import { Box, ListItem, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { Highlight } from 'react-instantsearch';

import Price from '@/components/Price/Price';
import {
  Chip,
  ImagePlaceholder,
} from '@/components/Search/SearchBox/SearchBox.style';

export function ProductHitContent({ hit, primary, secondary }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        flex: 1,
        px: 2,
        py: 1,
      }}>
      <Box
        sx={{
          width: 78,
          height: 78,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 1,
          border: '1px solid',
          borderColor: 'grayscale.300',
          borderRadius: 1,
        }}>
        {hit?.image_url ? (
          <Image
            src={hit.image_url}
            alt={primary}
            width={60}
            height={60}
            style={{ objectFit: 'contain' }}
          />
        ) : (
          <ImagePlaceholder />
        )}
      </Box>

      <Stack sx={{ minWidth: 0 }}>
        {secondary && (
          <Chip size="small" uppercase>
            {secondary}
          </Chip>
        )}
        <Typography
          data-test-subject="asset-name"
          variant="h6Redesign"
          color="primary.main"
          sx={{
            '& mark': {
              backgroundColor: 'transparent',
              color: 'primary.dark',
            },
          }}>
          {hit?._highlightResult?.name ? (
            <Highlight hit={hit} attribute="name" />
          ) : (
            primary
          )}
        </Typography>
        <Price
          price={hit?.rental_price}
          priceBasis={hit?.rental_price_basis}
          initialPrice={hit?.premium_product_original_price}
        />
      </Stack>
    </Box>
  );
}

ProductHitContent.propTypes = {
  hit: PropTypes.object,
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string,
};

export default function AutocompleteRow({
  id,
  primary,
  hit,
  href,
  secondary,
  highlighted,
  onSelect,
  onMouseEnter,
}) {
  return (
    <ListItem
      id={id}
      role="option"
      aria-selected={highlighted}
      disablePadding
      component={href ? Link : 'li'}
      href={href || undefined}
      sx={{
        backgroundColor: highlighted ? 'action.hover' : 'transparent',
        cursor: 'pointer',
        minHeight: 56,
        color: 'inherit',
        textDecoration: 'none',
      }}
      onMouseEnter={onMouseEnter}
      onClick={onSelect}>
      <ProductHitContent hit={hit} primary={primary} secondary={secondary} />
    </ListItem>
  );
}

AutocompleteRow.propTypes = {
  id: PropTypes.string.isRequired,
  primary: PropTypes.string.isRequired,
  hit: PropTypes.object,
  href: PropTypes.string,
  secondary: PropTypes.string,
  highlighted: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
};
